import { createTheme } from "@nextui-org/react"

const theme = createTheme({
    type: "light",
    theme: {
        colors: {
            // Brand color (primary)
            brandColor100: "#FEE8FA",
            brandColor200: "#FDD2F8",
            brandColor300: "#F9BBF7",
            brandColor400: "#F0A7F4",
            brandColor500: "#E08AED",
            brandColor600: "#B664CB",
            brandColor700: "#8D45AA",
            brandColor800: "#672C89",
            brandColor900: "#4A1A71",

            // Brand color (secondary)
            brandColorS100: "#FFFAD6",
            brandColorS200: "#FFF4AE",
            brandColorS300: "#FFEC86",
            brandColorS400: "#FFE568",
            brandColorS500: "#FFD936",
            brandColorS600: "#DBB527",
            brandColorS700: "#B7931B",
            brandColorS800: "#937311",
            brandColorS900: "#7A5C0A",

            // Brand color (success)
            brandColorSuccess100: "#F2FBD1",
            brandColorSuccess200: "#E3F8A4",
            brandColorSuccess300: "#C8EA74",
            brandColorSuccess400: "#AAD64F",
            brandColorSuccess500: "#82BC1E",
            brandColorSuccess600: "#69A115",
            brandColorSuccess700: "#52870F",
            brandColorSuccess800: "#3D6D09",
            brandColorSuccess900: "#2E5A05",

            // Brand color (info)
            brandColorInfo100: "#CCF3FF",
            brandColorInfo200: "#99E1FF",
            brandColorInfo300: "#67CBFF",
            brandColorInfo400: "#41B3FF",
            brandColorInfo500: "#028DFF",
            brandColorInfo600: "#016DDB",
            brandColorInfo700: "#0151B7",
            brandColorInfo800: "#003993",
            brandColorInfo900: "#00287A",

            // Brand color (warning)
            brandColorWarn100: "#FEF9CE",
            brandColorWarn200: "#FEF29D",
            brandColorWarn300: "#FEE96C",
            brandColorWarn400: "#FDDF48",
            brandColorWarn500: "#FCD00C",
            brandColorWarn600: "#D8AE08",
            brandColorWarn700: "#B58E06",
            brandColorWarn800: "#926F03",
            brandColorWarn900: "#785A02",

            // Brand color (danger)
            brandColorDanger100: "#FFE6E1",
            brandColorDanger200: "#FFC7C3",
            brandColorDanger300: "#FFA6A8",
            brandColorDanger400: "#FF909D",
            brandColorDanger500: "#FF6B8B",
            brandColorDanger600: "#DB4E7A",
            brandColorDanger700: "#B7356A",
            brandColorDanger800: "#93225B",
            brandColorDanger900: "#7A1451",

            // Primary color
            primary: "$brandColor600", 
            primaryBorder: "$brandColor500",
            primaryBorderHover: "$brandColor600",
            primaryLight: "$brandColor200",
            primaryLightActive: "$brandColor400",
            primaryLightContrast: "$brandColor600",
            primaryLightHover: "$brandColor300",
            primaryShadow: "$brandColor500",
            primarySolidContrast: "$white",
            primarySolidHover: "$brandColor700",

            // Secondary color
            secondary: "$brandColorS600", 
            secondaryBorder: "$brandColorS500",
            secondaryBorderHover: "$brandColorS600",
            secondaryLight: "$brandColorS200",
            secondaryLightActive: "$brandColorS400",
            secondaryLightContrast: "$brandColorS600",
            secondaryLightHover: "$brandColorS300",
            secondaryShadow: "$brandColorS500",
            secondarySolidContrast: "$black",
            secondarySolidHover: "$brandColorS700",

            // Success color
            success: "$brandColorSuccess600", 
            successBorder: "$brandColorSuccess500",
            successBorderHover: "$brandColorSuccess600",
            successLight: "$brandColorSuccess200",
            successLightActive: "$brandColorSuccess400",
            successLightContrast: "$brandColorSuccess600",
            successLightHover: "$brandColorSuccess300",
            successShadow: "$brandColorSuccess500",
            successSolidContrast: "$black",
            successSolidHover: "$brandColorSuccess700",

            // Warning color
            warning: "$brandColorWarn600", 
            warningBorder: "$brandColorWarn500",
            warningBorderHover: "$brandColorWarn600",
            warningLight: "$brandColorWarn200",
            warningLightActive: "$brandColorWarn400",
            warningLightContrast: "$brandColorWarn600",
            warningLightHover: "$brandColorWarn300",
            warningShadow: "$brandColorWarn500",
            warningSolidContrast: "$black",
            warningSolidHover: "$brandColorWarn700",

            // Error color
            error: "$brandColorDanger600", 
            errorBorder: "$brandColorDanger500",
            errorBorderHover: "$brandColorDanger600",
            errorLight: "$brandColorDanger200",
            errorLightActive: "$brandColorDanger400",
            errorLightContrast: "$brandColorDanger600",
            errorLightHover: "$brandColorDanger300",
            errorShadow: "$brandColorDanger500",
            errorSolidContrast: "$white",
            errorSolidHover: "$brandColorDanger700"
        },
        fonts: {
            sans: `Montserrat, 'Helvetica Neue', sans-serif`,
            mono: `Menlo, Monaco, 'Lucida Console', 'Liberation Mono',
            'DejaVu Sans Mono', 'Bitstream Vera Sans Mono'`
        }
    }
})

export default theme